import React from 'react'

const Heartrob: React.FC = () => {
	return (
		<div className='timeline--heartrob timeline-section'>
			<div className='timeline--heartrob__event'>
				<div className='heartrob--gallery'>
					<img src='/images/timeline/heartrob.png' alt='Mummy Lillian with Daddy Emeka' />
					<img src='/images/timeline/heartrob-svg.svg' alt='' />
				</div>

				<div className='heartrob--content'>
					<h5>Our pastor’s Heartthrob</h5>

					<p>
						Then the journey began one fateful day in December 2001. For the sake of a generation, her steps were ordered by the
						Lord to be joined together with our Daddy.
					</p>
					<svg width='216' height='33' viewBox='0 0 216 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M3.99994 8.46405C38.9533 6.15486 28.4479 7.48704 51.2669 5.18349C74.086 2.87993 320.139 4.00081 134.286 8.6802C-51.5679 13.3596 178.35 15.722 198.214 23.4189C202.829 25.2069 207.446 27.5079 212.206 29.0453'
							stroke='#DF5A33'
							strokeWidth='6.36225'
							strokeLinecap='round'
						/>
					</svg>
				</div>
			</div>
		</div>
	)
}

export default Heartrob
